import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types"; // Import PropTypes
import apiClient from "../../utils/apiClient";
import useUser from "../../hooks/useUser";
import { socket } from "../../utils/socket";
const UnreadMessagesContext = createContext();

export const UnreadMessagesProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState();
  const { userID } = useUser();

  useEffect(() => {
    const fetchAllUnreadMessages = async () => {
      try {
        const allUnreadMessages = await apiClient.get(
          `/chat/unreadMessages?userId=${userID}`
        );
        const data = allUnreadMessages.data.Chat;
        setUnreadCount(parseInt(data.length));
      } catch (error) {
        console.log("error", error);
      }
    };
    if (userID) {
      fetchAllUnreadMessages();
    }
  }, [userID, socket]); // Include dependencies

  return (
    <UnreadMessagesContext.Provider value={{ unreadCount, setUnreadCount }}>
      {children}
    </UnreadMessagesContext.Provider>
  );
};

// PropTypes validation
UnreadMessagesProvider.propTypes = {
  children: PropTypes.node.isRequired, // Validate children prop
};

// Custom hook to use the UnreadMessagesContext
export const useUnreadMessages = () => {
  return useContext(UnreadMessagesContext);
};
